/**
 * AsyncComponent
 * Code Splitting Component / Server Side Rendering
 */
// React import kept for side-effects if needed
// React import intentionally omitted to avoid unused error
import Loadable from 'react-loadable';
import IntlMessages from 'utils/intl-messages';

// Restaurants Form
export const AsyncRestaurantsFormComponent = Loadable({
  loader: () => import('pages/restaurants/restaurantsForm'),
  loading: () => (
    <div className='init-loading'>
      <IntlMessages id={'global.loading'} />
    </div>
  ),
});

// Restaurant Suppliers List
export const AsyncRestaurantSuppliersListComponent = Loadable({
  loader: () => import('pages/restaurants/restaurantSuppliersList'),
  loading: () => (
    <div className='init-loading'>
      <IntlMessages id={'global.loading'} />
    </div>
  ),
});
// Restaurant Branches Suppliers List
export const RestaurantBranchesSuppliersList = Loadable({
  loader: () => import('pages/restaurants/restaurantBranchesSuppliersList'),
  loading: () => (
    <div className='init-loading'>
      <IntlMessages id={'global.loading'} />
    </div>
  ),
});

// Restaurant Details
export const RestaurantDetails = Loadable({
  loader: () => import('pages/restaurants/restaurantDetails'),
  loading: () => (
    <div className='init-loading'>
      <IntlMessages id={'global.loading'} />
    </div>
  ),
});

export const RestaurantManagersListComponent = Loadable({
  loader: () => import('pages/restaurants/restaurantManagersList'),
  loading: () => (
    <div className='init-loading'>
      <IntlMessages id={'global.loading'} />
    </div>
  ),
});

// Suppliers List
export const AsyncSuppliersListComponent = Loadable({
  loader: () => import('pages/suppliers/suppliersList'),
  loading: () => (
    <div className='init-loading'>
      <IntlMessages id={'global.loading'} />
    </div>
  ),
});

// Suppliers Form
export const AsyncSuppliersFormComponent = Loadable({
  loader: () => import('pages/suppliers/suppliersForm'),
  loading: () => (
    <div className='init-loading'>
      <IntlMessages id={'global.loading'} />
    </div>
  ),
});

// Suppliers Add
export const AsyncSuppliersAddComponent = Loadable({
  loader: () => import('pages/suppliers/supplierAdd'),
  loading: () => (
    <div className='init-loading'>
      <IntlMessages id={'global.loading'} />
    </div>
  ),
});

// Suppliers users
export const AsyncSupplierUsersListComponent = Loadable({
  loader: () => import('pages/suppliers/supplierUsersList'),
  loading: () => (
    <div className='init-loading'>
      <IntlMessages id={'global.loading'} />
    </div>
  ),
});

// Suppliers users form
export const AsyncSupplierUsersFormComponent = Loadable({
  loader: () => import('pages/suppliers/supplierUsersForm'),
  loading: () => (
    <div className='init-loading'>
      <IntlMessages id={'global.loading'} />
    </div>
  ),
});

// App users list
export const AsyncAppUsersListComponent = Loadable({
  loader: () => import('pages/appUsers/appUsersList'),
  loading: () => (
    <div className='init-loading'>
      <IntlMessages id={'global.loading'} />
    </div>
  ),
});

// App users form
export const AsyncAppUsersFormComponent = Loadable({
  loader: () => import('pages/appUsers/appUsersForm'),
  loading: () => (
    <div className='init-loading'>
      <IntlMessages id={'global.loading'} />
    </div>
  ),
});

// Restaurant Supplier Emails
export const RestaurantSupplierEmails = Loadable({
  loader: () => import('pages/restaurants/restaurantSupplierEmails'),
  loading: () => (
    <div className='init-loading'>
      <IntlMessages id={'global.loading'} />
    </div>
  ),
});

// OTP List
export const OTPList = Loadable({
  loader: () => import('pages/sms-otp/otpList'),
  loading: () => (
    <div className='init-loading'>
      <IntlMessages id={'global.loading'} />
    </div>
  ),
});

// Countries List
export const CountriesList = Loadable({
  loader: () => import('pages/countries/countriesList'),
  loading: () => (
    <div className='init-loading'>
      <IntlMessages id={'global.loading'} />
    </div>
  ),
});

// Country Form
export const CountryForm = Loadable({
  loader: () => import('pages/countries/countryForm'),
  loading: () => (
    <div className='init-loading'>
      <IntlMessages id={'global.loading'} />
    </div>
  ),
});
